export default "/images/vendor/flag-icon-css/flags/4x3/ng.svg?b69ed1e58b69dcadbf0e30265064ee70";